import React, { Component, useState, useEffect } from 'react';
import {styles, makeStyles, Theme, createStyles } from '@material-ui/core';
import {CircularProgress, LinearProgress} from '@material-ui/core';
import "./Loading.css"

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
    },
  }));

export function Loading(props){
    const [type, setType] = useState(true)
    const classes = useStyles();

    useEffect(()=>{
        if(props.type == 'circle'){
            setType(true)
        }
        if(props.type == 'line'){
            setType(false)
        }
    },[])

return(
    <>
    <div className="backLoading">
    { type ? 
    <div className="circleLoading">
      <CircularProgress color="secondary" />
    </div> : <LinearProgress color="secondary"/>
    }
    </div>
    </>
)
}